import { createSelector } from 'reselect';

import { getSidebarSettings } from '../utils/utils';

const getUi = state => state.ui;

export const selectSidebarSettings = createSelector([getUi], getSidebarSettings);

export const selectWidthXS = createSelector([getUi], ui => ui.lessThan.small);
